import { v4 as uuid } from 'uuid';
import { Option, Variant } from '../models';
import mixValues from './mixValues';

function checkMixedLength<T>(mixed: T[][]): boolean {
  if (mixed.length > 0) {
    return mixed[0].length > 0;
  }
  return false;
}

function buildVariant(values: string[]): Partial<Variant> {
  return {
    title: '',
    option: {
      option1: values[0] || '',
      option2: values[1] || '',
      option3: values[2] || '',
    },
    price: 0.0,
    compareAtPrice: 0.0,
    photos: null,
    sku: '',
    _id: uuid(),
    active: true,
  };
}

function compareVariants(base: Variant, compareTo: Variant): boolean {
  if (base.option && compareTo.option) {
    const {
      option: { option1: baseValue1, option2: baseValue2, option3: baseValue3 },
    } = base;
    const {
      option: {
        option1: compareValue1,
        option2: compareValue2,
        option3: compareValue3,
      },
    } = compareTo;
    return (
      baseValue1 === compareValue1 &&
      baseValue2 === compareValue2 &&
      baseValue3 === compareValue3
    );
  }
}

function generateVariantsHook(options: Option[], variants: Variant[]) {
  const mixedValues = mixValues(
    options
      .slice()
      .map(({ values }) => values)
      .filter((x) => !!x)
  );
  if (checkMixedLength(mixedValues)) {
    let generatedVariants = mixedValues
      .map((values) => buildVariant(values))
      .flat(Infinity) as Variant[];

    generatedVariants = generatedVariants.map((generatedVariant) => {
      const filtered = variants.filter((currentVariant) =>
        compareVariants(generatedVariant, currentVariant)
      );
      if (filtered.length > 0) {
        return filtered[0];
      }
      return generatedVariant;
    });
    return generatedVariants;
  }
  return variants;
}

export default generateVariantsHook;
